import { Platform } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UserService } from './user.service';
import { StorageService } from './storage.service';
import { environment, AUTH_SERVER_ADDRESS } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class AuthenticationService {

	authenticationState = new BehaviorSubject(false);
	currentToken = new BehaviorSubject(false);

	//AUTH_SERVER_ADDRESS:  string  =  'http://dev.arriva.gal/plataforma/api';

	constructor(
		private httpClient: HttpClient,
		private userService: UserService,
		private storage: Storage,
		private storageService: StorageService,
		private plt: Platform
	) {
		this.plt.ready().then(() => {
			this.initStorage();
		});
	}

	async initStorage() {
		try {
			await this.storageService.isReady();
			this.checkToken();
		} catch (error) {
			console.error('Error initializing storage:', error);
			// Reintentar después de un breve delay
			setTimeout(() => {
				this.initStorage();
			}, 1000);
		}
	}

	checkToken() {
		this.storageService.get('TOKEN_KEY').then(res => {
			if (res) {
				this.authenticationState.next(true);
				this.currentToken.next(res);
				this.userService.syncUserActivo().subscribe();
			}
		})
	}

	login(credentials) {
		return this.httpClient.post(`${AUTH_SERVER_ADDRESS}/v1/login`, credentials).pipe(
			tap(async (res) => {
				if (res) {
					await this.storageService.set('TOKEN_KEY', res['token']);
					this.authenticationState.next(true);
					this.currentToken.next(res['token']);
					console.log(res['usuario']);
					this.userService.setUserActivo(res['usuario']);
				}
			})
		);
	}

	register(credentials) {
		credentials.username = credentials.email;
		credentials.source = 'app';
		if (!credentials.marketing) {
			delete credentials.marketing;
		}
		return this.httpClient.post(`${AUTH_SERVER_ADDRESS}/v1/registro`, credentials).pipe(
			tap(async (res) => {
				if (res) {
					await this.storageService.set('TOKEN_KEY', res['token']);
					this.authenticationState.next(true);
					this.currentToken.next(res['token']);
					this.userService.setUserActivo(res['usuario']);
				}
			})
		);
	}

	requestPasswordReset(reference: string) {
		return this.httpClient.post(`${AUTH_SERVER_ADDRESS}/v1/solicitar-reset-password`, { reference });
	}

	resendActivation(reference: string) {
		return this.httpClient.post(`${AUTH_SERVER_ADDRESS}/v1/reenviar-activacion`, { reference });
	}

	logout() {
		return this.storageService.remove('TOKEN_KEY').then(() => {
			this.authenticationState.next(false);
			this.currentToken.next(false);
			this.userService.delUserActivo();

		});
	}

	isAuthenticated() {
		if (this.authenticationState.value) {
			return true;
		}
		return false;
	}

	isLoggedIn() {
		return this.storageService.get('TOKEN_KEY').then(res => {
			if (res) {
				this.authenticationState.next(true);
				this.currentToken.next(res);
				return true;
			}
			else {
				return false;
			}
		})
	}



	getToken() {
		return this.currentToken.value;
	}


}